import { apiKeys, apiMethods, apiStatuses, apiUrls } from '@/store/api/constants';
import { clearData, fetchData } from '@/store/slices/fetch-slice';
import { getData, getStatus } from '@/store/slices/helpers/helpers';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InarrayCheckComponent from '../helpers/InarrayCheckComponent';

function useGetDropdownListOptions() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const getDropdownListData = getData(state, apiKeys.dropdownlistMaster, []);
  const getSchemeListData = getData(state, apiKeys.schemeMaster, []);
  const getDropdownListStatus = getStatus(state, apiKeys.dropdownlistMaster, '');
  const getDropdownListLoading = apiStatuses.pending === getDropdownListStatus;

 
  useEffect(() => {
    dispatch(
      fetchData({
        url: apiUrls.dropdownlistMaster,
        method: apiMethods.GET,
        key: apiKeys.dropdownlistMaster
      })
    );
  }, [dispatch]);

  const getDropdownListOptions = useMemo(() => {
    return getDropdownListData.map(({ id, dropListId, dropdownListName }) => ({
      id: id || dropListId,
      label: dropdownListName
    }));
  }, [getDropdownListData]);

  const planningModeOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 1 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const offerOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 2 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const deviceOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 3 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const planIntervalOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 4 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      })); 
  }, [getDropdownListData]);

  const prospectCategoryOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 8 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const ageGroupOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 9 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const prospectTimings = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 10 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const CustCategory = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 16 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const primeCustCategory = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 13 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const priceGroupOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 17 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const attPunchVisitType = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 21 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const planSchGrpOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 22 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const employmentOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 23 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const moduleOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 25 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const transportModeOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 26 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const weekdaysOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 27 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const expenseType = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 30 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const claimCategory = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 31 && option.activeStatus === "1" &&
      option.dropListId !== 172 && option.dropListId !== 173) 
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const expenseCategory = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 33 && option.activeStatus === "1" )
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  const workTypeOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 40 && option.activeStatus === "1" )
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: dropdownListName
      }));
  }, [getDropdownListData]);

  /* Foods Scheme*/
  const schemeCategoryOptions = useMemo(() => {
    return getDropdownListData
      .filter((option) => option.dropdownId === 42 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        // label: `${dropdownListName} - ${dropListId}`
        label: `${dropdownListName}`
      })); 
  }, [getDropdownListData]);

  const schemeGroupOptions = useMemo(() => {
    let scheme_group_array = []
    let filtered_dropdown_list_data = []
    getSchemeListData.map((vk,lk)=>{
      getDropdownListData.map((vk1,lk1)=>{
        if(vk.groupName == vk1.dropdownListName){
          scheme_group_array.push(vk1.dropdownListName)
        }
      })
    })
   
    return getDropdownListData
      // .filter((option) => option.dropdownId === 43 && option.activeStatus === "1"
      //  && !InarrayCheckComponent(option.dropdownListName,scheme_group_array ))
      .filter((option) => option.dropdownId === 43 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: `${dropdownListName}`
      })); 
  }, [getDropdownListData]);

  const averageRuleOptions = useMemo(() => {
    let scheme_group_array = []
    let filtered_dropdown_list_data = []
    getSchemeListData.map((vk,lk)=>{
      getDropdownListData.map((vk1,lk1)=>{
        if(vk.groupName == vk1.dropdownListName){
          scheme_group_array.push(vk1.dropdownListName)
        }
      })
    })
     let abc = getDropdownListData
      // .filter((option) => option.dropdownId === 43 && option.activeStatus === "1" 
      // && !InarrayCheckComponent(option.dropdownListName,scheme_group_array ))
      .filter((option) => option.dropdownId === 54 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: `${dropdownListName}`
      })); 
      return getDropdownListData
      // .filter((option) => option.dropdownId === 43 && option.activeStatus === "1"
      //  && !InarrayCheckComponent(option.dropdownListName,scheme_group_array ))
      .filter((option) => option.dropdownId === 54 && option.activeStatus === "1")
      .map(({ id, dropListId, dropdownListName }) => ({
        id: id !== undefined ? id : dropListId,
        label: `${dropdownListName}`
      })); 
  }, [getDropdownListData]);

  useEffect(
    () => () => {
      dispatch(clearData({ key: [apiKeys.dropdownlistMaster] }));
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      getDropdownListData,
      getDropdownListOptions,
      getDropdownListStatus,
      getDropdownListLoading,
      employmentOptions,
      moduleOptions,
      deviceOptions,
      offerOptions,
      ageGroupOptions,
      prospectTimings,
      weekdaysOptions,
      prospectCategoryOptions,
      transportModeOptions,
      planSchGrpOptions,
      planningModeOptions,
      planIntervalOptions,
      primeCustCategory,
      CustCategory,
      attPunchVisitType,
      expenseType,
      expenseCategory,
      priceGroupOptions,
      claimCategory,
      workTypeOptions,
      schemeCategoryOptions,
      schemeGroupOptions,
      averageRuleOptions
    }),
    [
      getDropdownListData,
      getDropdownListOptions,
      getDropdownListStatus,
      getDropdownListLoading,
      employmentOptions,
      moduleOptions,
      deviceOptions,
      offerOptions,
      ageGroupOptions,
      prospectTimings,
      weekdaysOptions,
      prospectCategoryOptions,
      transportModeOptions,
      planSchGrpOptions,
      planningModeOptions,
      planIntervalOptions,
      primeCustCategory,
      CustCategory,
      attPunchVisitType,
      expenseType,
      expenseCategory,
      priceGroupOptions,
      claimCategory,
      workTypeOptions,
      schemeCategoryOptions,
      schemeGroupOptions,
      averageRuleOptions
    ]
  );
}

export default useGetDropdownListOptions;
